import { OfflineUploadSourceType } from './OfflineEventSetUpload';

export interface UploadTagStats {
  // Total events in ingestor.
  count: number;
  countNew: number;
  countRepeat: number;

  // Count of matched events in ingestor (excluding duplicates)
  countMatched: number;

  // Count of events labeled as benchmark events in ingestor
  countBenchmarked: number;

  // Count of events that were unmatchable and not sent to facebook for matching purposes
  countUnmatchable: number;

  // Count of events that were uploaded to facebook
  countUploaded: number;

  // Revenue
  value: number;
  valueNew: number;
  valueRepeat: number;

  // Value of the events considered unmatchable
  valueUnmatchable: number;

  // Facebook
  fbSentCount: number;
  fbMatchCount: number;
  fbValidCount: number;
  fbDupCount: number;

  uploadSourceType: OfflineUploadSourceType[];
}

export const exampleUploadTagStats: UploadTagStats = {
  count: 2,
  countNew: 1,
  countRepeat: 1,
  countMatched: 1,
  countBenchmarked: 1,
  countUnmatchable: 1,
  countUploaded: 1,
  value: 2,
  valueNew: 1,
  valueRepeat: 1,
  valueUnmatchable: 1,
  fbSentCount: 10,
  fbMatchCount: 8,
  fbValidCount: 8,
  fbDupCount: 2,
  uploadSourceType: [OfflineUploadSourceType.OfflineEventSet],
};
